import api from 'utils/api';

export const getListStudent = async (data) => {
    const response = await api.get('/users/students', { params: data });
    return response.data;
};

export const getListStudentDropdown = async (params) => {
    const response = await api.get('/users/students/dropdown', { params });
    return response.data;
};

export const updateStudent = async (id, data) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
};

export const deleteStudent = async (data) => {
    const response = await api.delete(`/users`, { data: data });
    return response.data;
};

export const addStudent = async (data) => {
    const response = await api.post(`/users`, data);
    return response.data;
};

export const uploadStudents = async (data) => {
    const response = await api.post('/users/import-student', data);
    return response.data;
};

export const addStudentClass = async (id, data) => {
    const response = await api.post(`/classes/${id}/assign`, data);
    return response.data;
};

export const getStudent = async (id) => {
    const response = await api.get(`/users/students/${id}`);
    return response.data;
};

export const getStudentHistory = async (id, type, params) => {
    const response = await api.get(`/users/${id}/history/${type}`, { params });
    return response.data;
};
